import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import router from "@/router";
import Screentest from "@/store/modules/Screentest";
import UserAgent from "@/store/modules/UserAgent";

import animationsData from "@/store/data/animationsData";

const vuexLocal = new VuexPersistence({
  modules: ["Quiz"],
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    animationsData,
    rotateLock: null,
    scrollPercentage: 0,
    currentQuestionId: 0,
    windowScrollPosition: 0,
    panzoomCounter: 0,
    links: {
      prescribingInfo: 'https://ad.doubleclick.net/ddm/trackclk/N7437.3434815PRIHEALTHCARESOLUTI/B26953163.323396948;dc_trk_aid=519953010;dc_trk_cid=165920516;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=',
      medicalGuide: 'https://www.novartis.us/sites/www.novartis.us/files/kesimpta_pmg.pdf'
    },
    questionsList: [
      'How do adult patients with RMS typically present to your practice?',
      'What factors or clinical measures do you consider when assessing patients with RMS?',
      'What is your perspective on CD20 and why is it an important target in RMS?',
      'How does the <nobr>B-cell</nobr> depletion data seen with KESIMPTA over the dosing period impact your thinking as you consider a potential treatment option?',
      'Can you describe the study design of the Phase 3 ASCLEPIOS clinical trials ASCLEPIOS I <nobr>and II?</nobr>',
      'Did you feel that the patients in the ASCLEPIOS trials were reflective of those you see in your practice?',
      'Can you explain the results of the primary end point in both ASCLEPIOS trials and why the effect of KESIMPTA on ARR is meaningful?',
      'How would you discuss the efficacy data from both ASCLEPIOS trials in terms of key MRI end points?',
      'Can you explain the relative risk reductions of CDP at <nobr>3 and</nobr> <nobr>6 months</nobr> in the prespecified meta-analysis of pooled data from the ASCLEPIOS trials and summarize what these results mean to you and your patients?',
      'Based on the ASCLEPIOS trials, what questions or concerns should physicians expect to address when counseling patients about treatment with KESIMPTA?',
      'Can you elaborate on the injection-related reactions seen in the ASCLEPIOS trials and how these data may inform your treatment decisions?',
      'Can you review the immunoglobulin data seen in the Phase 3 trials and explain why monitoring IgM and IgG levels is important during treatment with an anti-CD20 therapy?',
      'What impact does the new long-term Ig data have on your perceptions?',
      'Can you share your perspective on when you would choose KESIMPTA for patients with RMS and how you would approach getting them started on therapy?',
      'Can you describe how KESIMPTA is dosed and your experience with the Sensoready<sup>®</sup> pen?',
      'How does the Alongside™ KESIMPTA program help support your patients when either starting KESIMPTA or during treatment?',
      'Do you have any concluding remarks that you would like to share with our readers?',
    ]
  },
  mutations: {
    SET_ROTATE_LOCK(state, value) {
      state.rotateLock = value;
    },
    SET_SCROLL_PERCENTAGE(state, value) {
      state.scrollPercentage = value;
    },
    SET_CURRENT_QUESTION_ID(state, value) {
      state.currentQuestionId = value;
    },
    SET_WINDOW_SCROLL_POSITION(state, value) {
      state.windowScrollPosition = value;
    },
    INCREASE_PANZOOM_COUNTER(state) {
      state.panzoomCounter++;
    }
  },
  actions: {
    SET_SCROLL_PERCENTAGE(context, value) {
      context.commit('SET_SCROLL_PERCENTAGE', value);
    },
    SET_CURRENT_QUESTION_ID(context, value) {
      context.commit('SET_CURRENT_QUESTION_ID', value);
    },
    SET_WINDOW_SCROLL_POSITION(context, value) {
      context.commit('SET_WINDOW_SCROLL_POSITION', value);
    },
    INCREASE_PANZOOM_COUNTER(context) {
      context.commit('INCREASE_PANZOOM_COUNTER');
    }
  },
  modules: {
    Screentest,
    UserAgent,
  },
  plugins: !router.currentRoute.query.screentest ? [vuexLocal.plugin] : [],
});
